import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {SelectService} from "../../../../../services/select.service";

@Component({
  selector: 'app-admin-sensors-errosr-dialog',
  templateUrl: './admin-sensor-errors-dialog.component.html',
  styleUrls: ['./admin-sensor-errors-dialog.component.scss']
})
export class AdminSensorErrorsDialogComponent implements OnInit {
  public sensorName: any;
  public warnings: any;

  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    public selectService: SelectService,
  ) {
    this.sensorName = data.sensorName;
    this.warnings = data.warnings;
  }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}
